<div class="modal-header">
  <h4 class="modal-title pull-left">Share OM</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="modalRefShareListing.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="propForm" autocomplete="off" #formDir="ngForm" class="property-form" name="form">

    <div class="cf">
      <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-bottom-20">
        <div class="row">
          <div class="table-fixed table-v2">
            <div class="table-responsive margin0">
              <table class="table basictable row-border hover" id="tbl">
                <thead>
                  <tr>
                    <th style="width:100px">First Name<span class="star">*</span></th>
                    <th style="width:100px">Last Name<span class="star">*</span></th>
                    <th style="width:100px">Email Address<span class="star">*</span></th>
                    <th style="width:5px;" [hidden]="userListForOm.length<=1">
                      Remove
                    </th>
                    <th style="width:5px;">
                      <a class="filter btn  btn-circle btn-green adduserbtn" href="javascript:void(0);" tooltip="Add User" (click)="addNewUser()"><i class="fa fa-plus icon" aria-hidden="true"></i></a>
                    </th>
                  </tr>
                </thead>
                <tbody class="shareOmBody">
                  <tr *ngFor="let users of userListForOm; let i = index;">
                    <td>
                      <div class="form-group">
                        <input class="form-control FirstName" placeholder="First Name" [formControlName]="'txtFirstName'+getUserId(i)" [(ngModel)]="users.FirstName" required type="text" maxlength="50" autocomplete="off" (change)="checkValidationMessage(users,1)">
                        <div *ngIf="users.FirstNamevalidationMessage!=null&&users.FirstNamevalidationMessage!=''">
                          <p class="redtext">
                            {{users.FirstNamevalidationMessage}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <input class="form-control LastName" placeholder="Last Name" [formControlName]="'txtLastName'+getUserId(i)" [(ngModel)]="users.LastName" required type="text" maxlength="50" autocomplete="off" (change)="checkValidationMessage(users,2)">
                        <div *ngIf="users.LastNamevalidationMessage!=null&&users.LastNamevalidationMessage!=''">
                          <p class="redtext">
                            {{users.LastNamevalidationMessage}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="form-group">
                        <input class="form-control emailId" placeholder="Email Address" [formControlName]="'txtEmail'+getUserId(i)" [(ngModel)]="users.EmailForShare" required type="text" maxlength="100" autocomplete="off" (change)="checkValidationMessage(users,3)">
                        <div *ngIf="users.EmailvalidationMessage!=null&&users.EmailvalidationMessage!=''">
                          <p class="redtext">
                            {{users.EmailvalidationMessage}}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td [hidden]="userListForOm.length<=1">
                      <a href="javascript:void(0);" (click)="onRemoveUser(users.Id)" class="remove" tooltip="Remove" placement="top">
                        <i class="icofont icofont-close" aria-hidden="true"></i>
                      </a>
                    </td>
                    <td>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr *ngIf="userListForOm?.length == 0 ">
                    <td colspan="5" class="odd no-data-available">
                      <div class="nodata">
                        <i class="fa fa-exclamation-triangle icon"></i>
                        <p>No Data Available</p>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>

          </div>
        </div>

        <!--<div class="form-group">
          <label class="form-label">Email Address<span class="star">*</span></label>
          <div class="textbox-date">
            <tag-input [(ngModel)]="mailIds" secondaryPlaceholder="Email Address" placeholder="+ Email IDs" [errorMessages]="errorMessages" [validators]="validators" [separatorKeyCodes]="keyCode">
            </tag-input>
            <p class="redtext" *ngIf="mailIds.length == 0  && isShareSubmit">Email Address is required</p>
            <h5 class="infotext">
              Use a comma or space to separate multiple email addresses.
            </h5>
          </div>
        </div>-->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 margin-bottom-20">
        <div class="form-group">
          <label class="form-label">Description <span class="star">*</span></label>
          <input class="form-control" formControlName="txtDescription" placeholder="Description" maxlength="100" [(ngModel)]="sharedList.Description" required type="text">
          <p class="redtext" *ngIf="(Validation.IsinValid(sharedList.Description) && isShareSubmit) ||(txtDescription.invalid && txtDescription.touched)">Description is required</p>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <div class="form-group">
          <label class="form-label">
            Expiration Date
            <span class="star">*</span>
          </label>
          <div class="textbox-date">
            <input bsDatepicker formControlName="expiryDate" class="form-control" type="text" placeholder="Expiry Date" [(ngModel)]="sharedList.ExpiryDate">
            <i class="icofont icofont-ui-calendar icon"></i>
            <div *ngIf="(Validation.IsinValid(sharedList.ExpiryDate) && isShareSubmit )||(expiryDate.invalid && expiryDate.invalid)">
              <p class="redtext">
                Expiration Date is required
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="table-responsive shared-om-table table-v-scroll table-fixed import-prospect-table margin-bottom-20" *ngIf="(SourcePage==null||SourcePage==''||SourcePage!='Property-Details')" style="width: 100%">
      <table id="openro-data" class="table basictable row-border hover" datatable [dtOptions]="dtoptions">
        <thead>
          <tr>
            <th>Property Name</th>
            <th>State</th>
            <th>City</th>
            <th>Status</th>
            <th data-orderable="false">Brokers</th>
          </tr>
        </thead>
        <tbody>
          <ng-container>
            <tr *ngFor="let item of propertyList; let i = index">
              <td class="whitespacenowrap">
                <p class="property-name">
                  <a target="_blank" href="#" routerLink="/viewproperty/{{item.Guid}}">
                    {{item.PropertyName}}
                    <span class="Off-Market margin-left-5">{{item.PropertyType}}</span>
                  </a>
                </p>
              </td>
              <td class="whitespacenowrap">
                <p>
                  {{item.State}}
                </p>
              </td>
              <td class="whitespacenowrap">
                <p>{{item.City}}</p>
              </td>
              <td class="whitespacenowrap">
                <p [ngClass]="{'redtextlabel':(item.Status === 'Closed' || item.Status === 'Sold'),'greentextlabel':item.Status === 'Available','orangetextlabel':item.Status === 'Under Contract','not-available':item.Status === 'Not Available','Off-Market':(item.Status === 'Off-Market'||item.Status === 'BOV'||item.Status === 'Pre-Marketing')}">{{ item.Status }}</p>
              </td>
              <td class="whitespacenowrap tool-tip-break"><p placement="bottom" container="body" tooltip="{{item.Brokers? item.Brokers : '-'}}">{{item.Brokers ? commonService.GetPropertyTypeWithCount(item.Brokers) : '-' }}</p></td>
            </tr>
          </ng-container>
        </tbody>
        <tfoot>
          <tr *ngIf="propertyList?.length == 0">
            <td colspan="4" class="odd no-data-available">
              <div class="nodata">
                <i class="fa fa-exclamation-triangle icon"></i>
                <p>No Data Available</p>
              </div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
    <div class="text-right">
      <button type="button" [disabled]="disableButton == false" (click)="shareList()" class="btn btn-success btn-lg">Share</button>
    </div>
  </form>
</div>
